// 現在の view を共有 URL のクエリ（?cx/cy/z）へ反映する副作用付きヘルパー。
//
// canvas-stage.tsx の rAF コールバックからこの 1 本だけを呼ぶ形に切り出している。
// history.replaceState の第 1 引数の扱いに固有の落とし穴（下記）があり、
// 巨大な CanvasStage を丸ごとレンダリングせずに回帰検証できるようにするため。
//
// URL 文字列の組み立て自体は canvas-view-url.ts（純関数）が担当し、ここは
// window.location / window.history への接続のみを持つ。

import type { ViewState } from "./canvas-coordinates";
import { buildCanvasViewSearchString, deriveCenterStageFromView } from "./canvas-view-url";

/**
 * 現在の view を URL クエリ（?cx/cy/z）へ反映する。pathname / hash と既存の他クエリは保持する。
 *
 * pushState だと履歴が肥大化するため replaceState で現在エントリのみを置換する。
 * @meiden-connect/ui のルータ互換レイヤは history.state に独自値が入ることを防ぐため、
 * state は null/undefined であることを要求する（router.tsx の pushState(null, ...) と同様）。
 * 現在の history.state をそのまま渡すと AssertionError ('state' must be null or undefined)
 * となるため、第 1 引数は必ず null にする。
 */
export function replaceCanvasViewInUrl(
  view: ViewState,
  viewport: { readonly width: number; readonly height: number }
): void {
  const center = deriveCenterStageFromView(view, viewport);
  const nextSearch = buildCanvasViewSearchString(window.location.search, {
    centerStageX: center.centerStageX,
    centerStageY: center.centerStageY,
    zoom: view.zoom,
  });
  const nextUrl = `${window.location.pathname}${nextSearch}${window.location.hash}`;
  window.history.replaceState(null, "", nextUrl);
}
